/**
 * Selectable list of exchanges
 */
import { useEffect, useState } from 'react';
import { helpers, enums } from '@kattana-io/common';

import Image from '../../../../atoms/Image';
import Text from '../../../../atoms/Text';

import { decorateExchangeName } from '../../../../helpers/decorators';

import shevronDown from '../../../../assets/images/shevron_down.svg';
import shevronUp from '../../../../assets/images/shevron_up.svg';

import gateio from '../../../../assets/images/exchanges/gateio.svg';
import binance from '../../../../assets/images/exchanges/binance.svg';
import hitbtc from '../../../../assets/images/exchanges/hitbtc.png';
import uniswap from '../../../../assets/images/exchanges/uniswap.svg';
import pancakeswap from '../../../../assets/images/exchanges/pancakeswap.svg';
import sushiswap from '../../../../assets/images/exchanges/sushiswap.svg';
import traderjoe from '../../../../assets/images/exchanges/traderjoe.png';
import pangolin from '../../../../assets/images/exchanges/pangolin.svg';
import quickswap from '../../../../assets/images/exchanges/quickswap.svg';
import mdex from '../../../../assets/images/exchanges/mdex.svg';
import impossibleswap from '../../../../assets/images/exchanges/impossibleswap.svg';
import maiar from '../../../../assets/images/exchanges/maiar.svg';
import spookyswap from '../../../../assets/images/exchanges/spookyswap.svg';
import huobi from '../../../../assets/images/exchanges/huobi.svg';
import sunswap from '../../../../assets/images/exchanges/sunswap.png';
import justmoney from '../../../../assets/images/exchanges/justmoney.svg';
import kucoin from '../../../../assets/images/exchanges/kucoin.svg';
import kyber from '../../../../assets/images/exchanges/kyber.svg';
import biswap from  '../../../../assets/images/exchanges/biswap.svg';
import okxdex from  '../../../../assets/images/exchanges/okxdex.png';
import cherryswap from  '../../../../assets/images/exchanges/cherryswap.svg';

const imageMapping = {
  binance,
  hitbtc,
  gateio,
  uniswap,
  pancakeswap,
  sushiswap,
  traderjoe,
  pangolin,
  quickswap,
  mdex,
  impossibleswap,
  maiar,
  spookyswap,
  huobi,
  sunswap,
  justmoney,
  kucoin,
  kyber,
  biswap,
  okxdex,
  cherryswap
};

const getClassName = (selectedExchanges: string[], item: string) => {
  return selectedExchanges.includes(item)
    ? 'tickers__panel__exchanges__exchange tickers__panel__exchanges__exchange--active'
    : 'tickers__panel__exchanges__exchange';
};

interface IExchangesSelectorProps {
  tab: number
  selectedExchanges: string[];
  setSelectedExchanges: (val: string[]) => void;
}

const ExchangesSelector = (props: IExchangesSelectorProps) => {
  const { selectedExchanges, setSelectedExchanges, tab } = props;
  const [popped, setPopped] = useState(true);
  const [exchangesList, seteExchangesList] = useState([...helpers.exchanges.CEX_LIST, ...helpers.exchanges.DEX_LIST]);

  useEffect(() => {
    if (tab === enums.ETickerKind.ALL) {
      seteExchangesList([...helpers.exchanges.CEX_LIST, ...helpers.exchanges.DEX_LIST]);
    }

    if (tab === enums.ETickerKind.CEX) {
      seteExchangesList([...helpers.exchanges.CEX_LIST]);
    }

    if (tab === enums.ETickerKind.DEX) {
      seteExchangesList([...helpers.exchanges.DEX_LIST]);
    }
  }, [tab]);

  const onClick = (item: string) => {
    if (selectedExchanges.includes(item)) {
      setSelectedExchanges(selectedExchanges.filter((i) => i !== item));
    } else {
      setSelectedExchanges([...selectedExchanges, item]);
    }
  };

  return (
    <div className={`tickers__panel__exchanges_container tickers__panel__exchanges_container--${popped ? 'popped' : 'small'}`}>
      <div className='tickers__panel__exchanges'>
        {exchangesList.map((item) => <div className={getClassName(selectedExchanges, item)}
          key={item}
          onClick={() => onClick(item)}
        >
          <Text size={12}>{decorateExchangeName(item)}</Text>
          <div className="img_wrapper">
            <Image src={(imageMapping as any)[item]} size='s'></Image>
          </div>
        </div>)}
      </div>

      <div className='tickers__panel__exchanges__toggler' onClick={() => setPopped(!popped)}>
        <Image src={popped ? shevronUp : shevronDown} size='s'></Image>
      </div>
    </div>
  );
};

export default ExchangesSelector;
